module.exports = __webpack_public_path__ + "static/media/test_red.c835ece9.jpg";